import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { Camera, CameraResultType } from '@capacitor/camera';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-banking-details',
  templateUrl: './banking-details.page.html',
  styleUrls: ['./banking-details.page.scss'],
})
export class BankingDetailsPage implements OnInit {
  bankDetailForm: FormGroup;
  imageUrl: string;
  imagesArray: any = [];
  hasHelpOpend=false;
  // eslint-disable-next-line max-len
  successMessage= 'We have received your request to %.<br/><br/> Our registrations team will prepare the necessary paperwork and contact you within two business days.<br/><br/> If you would like to talk to us about your request please call us on <a href="tel:1300 809 484">1300 809 484</a>';
  constructor( private navCtrl: NavController,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public toastService: ToastService,
    public accessService: AccessService,
) {
      this.bankDetailForm = this.formBuilder.group({
      document: ['',[Validators.required]],
      bank: ['', [Validators.required]],
      accountHolderName: ['', [Validators.required]],
      accountNumber: ['', [Validators.required]],
      bsb: ['', [Validators.required]],
      branchName: [''],
    });}

  ngOnInit() {
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  onSubmitForm() {
    if (this.bankDetailForm.valid) {
      this.toastService.presentLoading();
      this.apiService.post('add-bank-detail', this.bankDetailForm.value).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            //console.log('Form Value:: ', this.bankDetailForm.value);
            this.navCtrl.navigateForward(['/confirmation-page'], {
              queryParams: {
                state : this.successMessage.replace("%",res.message),
                hasAddButton:false
              },
          });
          }
        },
        (err) => {
          this.toastService.presentToast('error','Something went wrong.');
          this.toastService.dismissLoading();
          //console.log(err);
        }
      );
    } else {
      this.bankDetailForm.markAllAsTouched();
    }
  }
  async selectImage() {
    const image = await Camera.getPhoto({
      resultType: CameraResultType.Base64,
    });
    if (image) {
      this.imageUrl = 'data:image/jpeg;base64,' + image.base64String;
      this.imagesArray.push({
        img: this.imageUrl,
        sameId: '',
      });
      this.bankDetailForm.controls.document.setValue(this.imagesArray);
    }
  }
  openHelp(){
    this.hasHelpOpend = !this.hasHelpOpend;
  }
}
